import { useState, useEffect } from "react"
import { FormInput } from "components/"

const Checkbox = (props: {
  checked?: boolean
  label: string
  checkedLabel?: string
  placeholder?: string
  disabled?: boolean
  style?: string
  onChange?: (arg0: number) => void
}) => {
  const [checked, setChecked] = useState(props.checked)
  useEffect(() => {
    setChecked(props.checked)
  }, [props.checked])
  return (
    <FormInput
      type="checkbox"
      disabled={props.disabled}
      className={props.style}
      label={props.label}
      name={props.label?.toLowerCase()}
      checked={!!checked}
      placeholder={props.placeholder ?? "Enter your text"}
      onChange={(e: any) => {
        props.onChange && props.onChange(e.target.checked ? 1 : 0)
        setChecked(e.target.checked)
      }}
    />
  )
}
export default Checkbox
